import { fetchConfig } from '@theme/utilities';
import { CartUpdateEvent } from '@theme/events';

/** @type {string} */
export const BUY_NOW_PENDING_KEY = 'theme-buy-now-checkout-pending';

/**
 * Marks that the customer was sent to checkout via Buy Now (used to clear cart if they return without purchasing).
 */
export function markBuyNowCheckoutPending() {
  try {
    sessionStorage.setItem(BUY_NOW_PENDING_KEY, '1');
  } catch {
    // sessionStorage may be unavailable in private browsing
  }
}

/**
 * Clears the cart when the customer returns to the storefront after abandoning a Buy Now checkout.
 */
export async function clearAbandonedBuyNowCart() {
  let isPending = false;

  try {
    isPending = sessionStorage.getItem(BUY_NOW_PENDING_KEY) === '1';
    if (isPending) {
      sessionStorage.removeItem(BUY_NOW_PENDING_KEY);
    }
  } catch {
    return;
  }

  if (!isPending) return;

  try {
    const response = await fetch(Theme.routes.cart_clear_url, fetchConfig('json'));
    if (!response.ok) return;

    const cart = await fetch(`${Theme.routes.cart_url}.js`).then((res) => res.json());
    document.dispatchEvent(
      new CartUpdateEvent(cart, 'buy-now-cleanup', { source: 'buy-now-cleanup' })
    );
  } catch (error) {
    console.error('Failed to clear abandoned Buy Now cart:', error);
  }
}

clearAbandonedBuyNowCart();
